import { useTranslation } from 'react-i18next'

const MARKETPLACES = [
  { tld: 'de', flag: '\u{1F1E9}\u{1F1EA}' },
  { tld: 'com', flag: '\u{1F1FA}\u{1F1F8}' },
  { tld: 'co.uk', flag: '\u{1F1EC}\u{1F1E7}' },
  { tld: 'fr', flag: '\u{1F1EB}\u{1F1F7}' },
  { tld: 'it', flag: '\u{1F1EE}\u{1F1F9}' },
  { tld: 'es', flag: '\u{1F1EA}\u{1F1F8}' },
]

interface MarketplaceChipSelectorProps {
  selected: string
  onSelect: (tld: string) => void
}

export function MarketplaceChipSelector({ selected, onSelect }: MarketplaceChipSelectorProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-wrap gap-2">
      {MARKETPLACES.map(({ tld, flag }) => (
        <button
          key={tld}
          type="button"
          onClick={() => onSelect(tld)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
            selected === tld
              ? 'bg-orange-500 text-white shadow-sm'
              : 'bg-neutral-100 dark:bg-neutral-700 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-200 dark:hover:bg-neutral-600'
          }`}
        >
          <span>{flag}</span>
          <span>{t(`amazonListing.marketplaces.${tld}`)}</span>
        </button>
      ))}
    </div>
  )
}
